import { render, staticRenderFns } from "./ring-group-dropdown.vue?vue&type=template&id=3c6cce0f"
import script from "./ring-group-dropdown.vue?vue&type=script&lang=js"
export * from "./ring-group-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports